'use client';

import React, { useState, useContext, forwardRef } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import { SmartCaptchaDialogContext } from './smart-captcha-dialog-context';

/** Yandex mounts its challenge outside the form's focus scope. */
export function CaptchaDialog({ challengeVisible = false, busy = false, onOpenChange, children, ...props }:
  React.ComponentProps<typeof Dialog> & { challengeVisible?: boolean; busy?: boolean }) {
  const [nestedChallengeVisible, setChallengeVisible] = useState(false);
  const active = challengeVisible || nestedChallengeVisible;
  const changeOpen = (open: boolean) => {
    if (!open && (active || busy)) return;
    onOpenChange?.(open);
  };
  return <SmartCaptchaDialogContext.Provider value={{ challengeVisible: active, busy, close: () => changeOpen(false), setChallengeVisible }}>
    <Dialog {...props} modal={false} onOpenChange={changeOpen}>{children}</Dialog>
  </SmartCaptchaDialogContext.Provider>;
}

export const CaptchaDialogContent = forwardRef<React.ElementRef<typeof DialogContent>, React.ComponentProps<typeof DialogContent>>(
  function CaptchaDialogContent({ className, style, ...props }, ref) {
    const { challengeVisible, busy, close } = useContext(SmartCaptchaDialogContext);
    return <DialogContent
      {...props}
      ref={ref}
      externalChallengeActive={challengeVisible}
      onBackdropClick={close}
      onInteractOutside={(event) => event.preventDefault()}
      onEscapeKeyDown={(event) => { if (challengeVisible || busy) event.preventDefault(); }}
      className={cn('max-h-[90dvh] overflow-y-auto !animate-none', className)}
      // Transforms make the fixed CAPTCHA challenge relative to the dialog.
      style={{ ...style, transform: 'none', inset: 0, margin: 'auto', height: 'fit-content' }}
    />;
  },
);
